import React, { Fragment } from 'react'
import { Button, Tabs } from 'antd'
import menuubody from "../../Assets/p4body.png";
import menuuSleeve from "../../Assets/p4sleeve.png";
import menuuCap from "../../Assets/p4cap.png";
import BodyTabThree from './ShirtThreeTabs/BodyTabThree';
import SleeveTabThree from './ShirtThreeTabs/SleeveTabThree';
import CapTabThree from './ShirtThreeTabs/CapTabThree';

const ShirtThreeTabs = ({handleCapColor, handleCapMarkingColor, handleCapId, capColors, capMarkingColor, handlesleevesColor, handleSleevesMarkingColor, handleSleeveId,  sleeveColors, sleevesMarkingColor, handleBodyColor, handleBodyMarkingColor, handleBodyId, bodyColors, bodyMarkingColors}) => {
    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <Tabs tabPosition="left">
                            <Tabs.TabPane
                                key="1"
                                tab={
                                    <Button>
                                        <img src={menuubody} alt="asd" />
                                        Body
                                    </Button>
                                }
                            >
                                <BodyTabThree
                                    handleBodyColor={handleBodyColor}
                                    handleBodyMarkingColor={handleBodyMarkingColor}
                                    handleBodyId={handleBodyId}
                                    bodyColors={bodyColors}
                                    bodyMarkingColors={bodyMarkingColors}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                key="2"
                                tab={
                                    <Button>
                                        <img src={menuuSleeve} alt="asd" />
                                        Sleeves
                                    </Button>
                                }
                            >
                                <SleeveTabThree
                                    handlesleevesColor={handlesleevesColor}
                                    handleSleevesMarkingColor={handleSleevesMarkingColor}
                                    handleSleeveId={handleSleeveId}
                                    sleeveColors={sleeveColors}
                                    sleevesMarkingColor={sleevesMarkingColor}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                key="3"
                                tab={
                                    <Button>
                                        <img src={menuuCap} alt="asd" />
                                        Cap
                                    </Button>
                                }
                            >
                                <CapTabThree
                                    handleCapColor={handleCapColor}
                                    handleCapMarkingColor={handleCapMarkingColor}
                                    handleCapId={handleCapId}
                                    capColors={capColors}
                                    capMarkingColor={capMarkingColor}
                                />
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ShirtThreeTabs